/* import __COLOCATED_TEMPLATE__ from './user-notification-schedule-day.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { i18n } from "discourse/lib/computed";
import TEMPLATE from "./user-notification-schedule-day.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "",
  dayLabel: i18n("day", "user.notification_schedule.%@")
}));